import AccordionModuleItems from "@components/AccordionModule/AccordionModuleItems";
import { AppAndCTAContainer } from "@components/AppAndCTAContainer";
import SliderOption from "@components/SliderOption";
import { getColours } from "@helpers";
import type { IAccordionModuleFields, IModuleFaq } from "@types-contentful";
import React, { useState } from "react";
import styled from "styled-components";

interface IAccordionModuleProps extends IAccordionModuleFields {
	accordionItems: IModuleFaq[];
}
type ContainerProps = {
	resetModuleMarginBottom: string;
	backgroundColour:
		| "Peach"
		| "Midnight Blue"
		| "Pale Peach"
		| "White"
		| "Watermelon"
		| "Mint Green"
		| "Green"
		| undefined;
};

const Container = styled.div<ContainerProps>`
  ${({ resetModuleMarginBottom }) => resetModuleMarginBottom === "Yes" && "margin-bottom: 0px !important"};
  padding: 40px 35px 40px 35px;
  background-color: ${(props) => getColours(props.backgroundColour)};
  @media (min-width: 834px) {
    padding: 40px 10% 75px 10%;
  }
  overflow: hidden;
`;

const MainHeader = styled.h2`
  margin-bottom: 24px;

  @media (min-width: 834px) {
    margin-bottom: 32px;
  }
`;
const ItemsHeader = styled.p`
  margin-bottom: 24px;

  @media (min-width: 834px) {
    margin-bottom: 32px;
  }
`;

const ContentfulAccordionModule = ({
	accordionItems,
	header,
	removeNegativeSpacingBelowModule,
	appStoreUrl,
	backgroundColour,
	ctaButtonColour,
	ctaButtonLabel,
	ctaButtonUrl,
	googlePlayUrl,
	name,
}: IAccordionModuleProps) => {
	const [active, setActive] = useState(0);
	const handleRadioChange = (event: { target: { id: string } }) => {
		setActive(Number(event.target.id));
	};

	const resetModuleMarginBottom = removeNegativeSpacingBelowModule;

	const sliderItems = accordionItems?.map((item: any) => {
		return {
			value: item.fields?.sliderTitle,
			iconName: item.fields?.sliderTitleIconRef,
			name: item.fields?.sliderTitle,
			steps: item.fields?.items,
			title: item.fields?.title,
		};
	});
	const toKebabCase = (str) => {
		return str
			.toLowerCase() // Convert to lowercase
			.replace(/\s+/g, "-") // Replace spaces with hyphens
			.replace(/[^\w-]/g, "") // Remove all non-word chars (except hyphens)
			.replace(/--+/g, "-") // Replace multiple hyphens with single hyphen
			.replace(/^-+/, "") // Trim hyphens from start
			.replace(/-+$/, ""); // Trim hyphens from end
	};

	// Example usage:
	const headerId = toKebabCase(header);

	return (
		<>
			<Container
				resetModuleMarginBottom={resetModuleMarginBottom}
				backgroundColour={backgroundColour}
			>
				<MainHeader id={headerId}>{header}</MainHeader>
				{sliderItems?.length > 1 && (
					<SliderOption
						page_name={ctaButtonUrl}
						cta_position={name}
						active={active}
						handleRadioChange={handleRadioChange}
						sliderItems={sliderItems}
						marginBottom={{ mobile: "24px", desktop: "32px" }}
					/>
				)}

				{sliderItems[active].title && (
					<ItemsHeader>{sliderItems[active].title}</ItemsHeader>
				)}
				{sliderItems[active]?.steps?.map((item: any, index: any) => (
					<AccordionModuleItems
						key={index + index}
						faq={{
							...item.fields,
							name: item.fields.name || undefined,
							iconRef: item.fields.iconRef || undefined,
							content: item.fields.content,
						}}
					/>
				))}
				{ctaButtonUrl && ctaButtonLabel && googlePlayUrl && appStoreUrl && (
					<AppAndCTAContainer
						//@ts-ignore
						ctaButtonUrl={ctaButtonUrl}
						ctaButtonColour={ctaButtonColour}
						name={name}
						ctaButtonLabel={ctaButtonLabel}
						googlePlayUrl={googlePlayUrl}
						appStoreUrl={appStoreUrl}
						marginTop="32px"
						position="relative"
						bgColor={backgroundColour}
						justifyContent="flex-start"
						bgColorDesktop={undefined}
					/>
				)}
			</Container>
		</>
	);
};

export default ContentfulAccordionModule;
